// Generates the `session.id` used to correlate log records — not a security
// token or identifier, just a grouping key for an app session's logs.
//
// `crypto.randomUUID` is only defined in a secure context: HTTPS pages and the
// loopback origins `http://localhost` / `http://127.0.0.1`. It is absent on any
// other plain-HTTP origin — e.g. a raw IP like `http://0.0.0.0` during local
// dev, or a checkout iframe a merchant embeds over HTTP — where reading it
// throws "crypto.randomUUID is not a function". Since this is only a correlation
// key, we fall back to a non-crypto id rather than crash.
export function generateLogCorrelationKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
